import { Theme } from '../../../UNSAFE_Theme';
import { baseVars, colorSchemeVars, scaleVars } from '../themeContract.css';
/* components will directly import themes for now, we will reintroduce the component themes into the global theme after 15.0 release
import { UserAssistanceRedwoodTheme } from '../../../UNSAFE_UserAssistance/themes/redwood/UserAssistanceTheme'; 
import { TextFieldRedwoodTheme } from '../../../UNSAFE_TextField/themes/redwood/TextFieldTheme';
import { FormLayoutRedwoodTheme } from '../../../UNSAFE_TextField/themes/redwood/FormLayoutTheme';
import { LabelRedwoodTheme } from '../../../UNSAFE_Label/themes/redwood/LabelTheme';
import { MessageBannerRedwoodTheme } from '../../../UNSAFE_MessageBanner/themes/redwood/MessageBannerTheme';
import { MessageToastRedwoodTheme } from '../../../UNSAFE_MessageToast/themes/redwood/MessageToastTheme';
import { ComponentMessageRedwoodTheme } from '../../../UNSAFE_ComponentMessage/themes/redwood/ComponentMessageTheme';
import { ReadonlyTextFieldInputRedwoodTheme } from '../../../UNSAFE_TextField/themes/redwood/ReadonlyTextFieldInputTheme';
import { ReadonlyTextFieldRedwoodTheme } from '../../../UNSAFE_TextField/themes/redwood/ReadonlyTextFieldTheme';
import { TextFieldInputRedwoodTheme } from '../../../UNSAFE_TextField/themes/redwood/TextFieldInputTheme';
import { DialogRedwoodTheme } from '../../../UNSAFE_Dialog/themes/redwood/DialogTheme';
import { DrawerPopupRedwoodTheme } from '../../../UNSAFE_DrawerPopup/themes/redwood/DrawerPopupTheme';
import { CollapsibleRedwoodTheme } from '../../../UNSAFE_Collapsible/themes/redwood/CollapsibleTheme';
import { WindowOverlayRedwoodTheme } from '../../../UNSAFE_WindowOverlay/themes/redwood/WindowOverlayTheme';
import { TooltipContentRedwoodTheme } from '../../../hooks/UNSAFE_useTooltip/themes/redwood/TooltipContentTheme';
import { SkeletonRedwoodTheme } from '../../../UNSAFE_Skeleton/themes/redwood/SkeletonTheme';
import { AvatarRedwoodTheme } from '../../../UNSAFE_Avatar/themes/redwood/AvatarTheme';
import { BaseButtonRedwoodTheme } from '../../../UNSAFE_BaseButton/themes/redwood/BaseButtonTheme';
import { ButtonLayoutRedwoodTheme } from '../../../UNSAFE_ButtonLayout/themes/redwood/ButtonLayoutTheme';
import { SplitMenuButtonRedwoodTheme } from '../../../UNSAFE_SplitMenuButton/themes/redwood/SplitMenuButtonTheme';
import { RadioRedwoodTheme } from '../../../UNSAFE_Radio/themes/redwood/RadioTheme';
import { RadioIconRedwoodTheme } from '../../../UNSAFE_Radio/themes/redwood/RadioIconTheme';
import { IndexerRedwoodTheme } from '../../../UNSAFE_Indexer/themes/redwood/IndexerTheme';
import { LinkRedwoodTheme } from '../../../UNSAFE_Link/themes/redwood/LinkTheme';
import { GroupedListRedwoodTheme } from '../../../UNSAFE_GroupedList/themes/redwood/GroupedListTheme';
import { TabBarItemRedwoodTheme } from '../../../UNSAFE_TabBarItem/themes/redwood/TabBarItemTheme';
import { PopupRedwoodTheme } from '../../../UNSAFE_Popup/themes/redwood/PopupTheme';
import { ProgressBarRedwoodTheme } from '../../../UNSAFE_ProgressBar/themes/redwood/ProgressBarTheme';
import { ProgressCircleRedwoodTheme } from '../../../UNSAFE_ProgressCircle/themes/redwood/ProgressCircleTheme';
import { FilePickerRedwoodTheme } from '../../../UNSAFE_FilePicker/themes/redwood/FilePickerTheme';
import { MenuDividerRedwoodTheme } from '../../../UNSAFE_Menu/themes/redwood/MenuDividerTheme';
import { MenuItemRedwoodTheme } from '../../../UNSAFE_Menu/themes/redwood/MenuItemTheme';
import { NavigationListItemRedwoodTheme } from '../../../UNSAFE_NavigationList/themes/redwood/NavigationListItemTheme';
import { RatingGaugeRedwoodTheme } from '../../../UNSAFE_RatingGauge/themes/redwood/RatingGaugeTheme';
*/

const Redwood: Theme = {
  name: 'redwood',
  /* components will directly import themes for now, we will reintroduce the component themes into the global theme after 15.0 release
  components: {
    Avatar: AvatarRedwoodTheme,
    Badge: BadgeRedwoodTheme,
    BaseButton: BaseButtonRedwoodTheme,
    ButtonLayout: ButtonLayoutRedwoodTheme,
    Label: LabelRedwoodTheme,
    Link: LinkRedwoodTheme,
    ComponentMessage: ComponentMessageRedwoodTheme,
    MessageBanner: MessageBannerRedwoodTheme,
    MessageToast: MessageToastRedwoodTheme,
    FilePicker: FilePickerRedwoodTheme,
    FormLayout: FormLayoutRedwoodTheme,
    Popup: PopupRedwoodTheme,
    ProgressBar: ProgressBarRedwoodTheme,
    ProgressCircle: ProgressCircleRedwoodTheme,
    TextField: TextFieldRedwoodTheme,
    TextFieldInput: TextFieldInputRedwoodTheme,
    UserAssistance: UserAssistanceRedwoodTheme,
    Radio: RadioRedwoodTheme,
    RadioIcon: RadioIconRedwoodTheme,
    RatingGauge: RatingGaugeRedwoodTheme,
    ReadonlyTextField: ReadonlyTextFieldRedwoodTheme,
    ReadonlyTextFieldInput: ReadonlyTextFieldInputRedwoodTheme,
    Collapsible: CollapsibleRedwoodTheme,
    Dialog: DialogRedwoodTheme,
    DrawerPopup: DrawerPopupRedwoodTheme,
    Skeleton: SkeletonRedwoodTheme,
    SplitMenuButton: SplitMenuButtonRedwoodTheme,
    WindowOverlay: WindowOverlayRedwoodTheme,
    TooltipContent: TooltipContentRedwoodTheme,
    Train: TrainRedwoodTheme,
    Indexer: IndexerRedwoodTheme,
    GroupedList: GroupedListRedwoodTheme,
    TabBarItem: TabBarItemRedwoodTheme,
    MenuDivider: MenuDividerRedwoodTheme,
    MenuItem: MenuItemRedwoodTheme,
    NavigationListItem: NavigationListItemRedwoodTheme,
    Floating: FloatingRedwoodTheme,
    MeterBar: MeterBarRedwoodTheme,
    MeterCircle: MeterCircleRedwoodTheme
  },
  */
  base: baseVars,
  colorScheme: colorSchemeVars,
  scale: scaleVars
};

export { Redwood };
